import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import MediaManager from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';

export interface Props {
  label?: string;
  className?: string;
}

export const PremiumFolderCreateButton: React.FC<Props> = ({
  label,
  className,
}) => {
  const [isMediaManagerShown, setShowMediaManager] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (window.location.search.includes('new_premium_folder')) {
      window.history.replaceState(
        null,
        document.title,
        window.location.pathname
      );
      setShowMediaManager(true);
    }
  }, [setShowMediaManager]);

  const closeMediaManagerAndReload = event => {
    setShowMediaManager(false);
    event && event.preventDefault();
    window.location.reload();
  };

  return (
    <>
      <Button
        className={className}
        view="b16-undisciplined-designers"
        onClick={() => setShowMediaManager(true)}
      >
        {label || t('common.addNew')}
      </Button>
      {isMediaManagerShown && (
        <MediaManager
          initialMediaSource={MediaSourceType.GALLERY}
          withMediaSourceSelector={false}
          withNewGallectionPopupOpen
          onDone={closeMediaManagerAndReload}
          onClose={closeMediaManagerAndReload}
          onlyNewPaidFolders
        />
      )}
    </>
  );
};
PremiumFolderCreateButton.displayName = 'PremiumFolderCreateButton';

export default PremiumFolderCreateButton;
